<template>
  <ButtonDefinitive
    label="Continuar"
    @click="next"
  />
</template>

<script>
import ButtonDefinitive from '@/components/Button/ButtonDefinitive.vue'

export default {
  name: "Step2-Footer",
  mounted() {
    this.$nextTick(() => {});
  },
  components: { ButtonDefinitive },
  methods: {
    next() {
      if (this.currentOrder.contactOrigin === null) {
        return this.showError("Debe seleccionar un contacto de origen")
      }
      if (!this.currentOrder.origin.description) {
        return this.showError("Debe seleccionar una dirección de origen")
      }
      if (!this.currentOrder.origin.lat || !this.currentOrder.origin.lng) {
        return this.showError('Ahora las direcciones deben estar correctamente ubicadas en el mapa 📍. Por favor, actualiza la dirección seleccionada.')
      }

      this.$store.dispatch("PROGRAMMED_PROGRESS_NAV_STEP", 3);
      this.$store.dispatch("STYLE_MAP_SAIO", false);
      this.$store.dispatch("STYLE_SHOW_PM_QUOTER", false);
      this.$store.dispatch("STYLE_PROGRAMMED_STEP_DIV_THREE_GENERAL");
      this.trackEvent('programado_paso_2_continuar', 'programado')
    }
  },
  computed: {
    currentOrder() {
      return this.$store.getters.PROGRAMMED_ORDER
    },
  },

};
</script>

<style></style>
